import React from 'react';
import { useTranslation } from 'react-i18next';
import { ContinueButtons } from '../atoms';
import { Header, Content } from '../organisms';

import styles from './ReportTemplate.module.scss';

export interface IReportTemplate {
	onSave: () => void;
	onHome: () => void;
}

export const ReportTemplate = (props: IReportTemplate) => {
	const { t } = useTranslation();

	return (
		<div className={styles.globalDihkFont + ' ' + styles.pageContent}>
			<Header label={t('header.label')} onClick={props.onHome} />
			<Content />
			<ContinueButtons label={t('submit')} onSave={props.onSave} />
		</div>
	);
};
